var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-avatar"},[_c('b-image',{attrs:{"src":_vm.imgSrc,"rounded":"","ratio":"1by1","responsive":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }